export default __webpack_public_path__ + "static/media/sports_esports_active.434fecde.svg";